import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";

const SearchForm = ({ onSearch }) => {
    const [dataSearch, setDataSearch] = useState({
        sTenHangHoa: "",
        sStatus: "",
        pageIndex: 1,
        pageSize: 20,
    });

    const [showModal, setShowModal] = useState(false);
    const toggleModal = () => setShowModal(!showModal);

    const onChangeData = (field) => (event) => {
        const value = event?.target?.value ?? "";
        setDataSearch((prev) => ({
            ...prev,
            [field]: value,
        }));
    };

    const handleSearch = () => {
        onSearch(dataSearch,1);
        if (showModal) {
            setShowModal(false);
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            handleSearch();
        }
    };

    // Hàm render các ô input dùng chung
    const renderFormFields = () => (
        <>
            <div className="input-sm-new input-new-18" style={{ flex: 1 }}>
                <label htmlFor="sTenHangHoa" className="font-color-default font-bold">Tìm kiếm</label>
                <input
                    id="sTenHangHoa"
                    type="text"
                    className="form-control input-sm"
                    placeholder="Tên hàng hoá"
                    onChange={onChangeData("sTenHangHoa")}
                    onKeyDown={handleKeyDown}
                    value={dataSearch.sTenHangHoa}
                />
            </div>
            <div className="input-sm-new input-new-18" style={{ flex: 1 }}>
                <label htmlFor="sStatus" className="font-color-default font-bold">Trạng thái</label>
                <select
                    id="sStatus"
                    name="sStatus"
                    value={dataSearch.sStatus}
                    onChange={onChangeData("sStatus")}
                    className="form-control input-sm"
                >
                    <option value="">Tất cả</option>
                    <option value="0">Bình thường</option>
                    <option value="1">Khóa</option>
                </select>
            </div>
        </>
    );

    return (
        <>
            <div className="card border-light mb-1 hidden-mobile-main show-table-main card-v2" style={{ marginBottom: 16 }}>
                <div className="card-body card-body-v2" style={{ padding: '12px 16px 8px 16px' }}>
                    <div className="search-new d-flex flex-row align-items-end justify-content-start gap-3">
                        {renderFormFields()}
                        <div className="input-sm-new input-new-18 search-main-new">
                            <button
                                type="button"
                                className="btn btn-info-new"
                                style={{ paddingTop: "7px" }}
                                onClick={handleSearch}
                            >
                                <i className="la la-search"></i>
                                <span> &nbsp; Tìm kiếm</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="repeater-default hide-table-main show-mobile-main hidden-des-main">
                <div className="col-sm-12">
                    <div className="form row">
                        <div className="col-12">
                            <button
                                type="button"
                                className="btn btn-info-new"
                                onClick={toggleModal}
                            >
                                Tìm kiếm <i className="la la-search"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                show={showModal}
                onHide={toggleModal}
                dialogClassName="modal-lg"
                className="modal-new modal fade text-left"
                backdrop="static"
            >
                <Modal.Header>
                    <h2 className="modal-title p-1">
                        Tìm kiếm
                    </h2>
                    <button type="button" className="close-popup-new" onClick={toggleModal}>
                        <img src="/app-assets/images/icon-dong-popup-v2.png" alt="close" />
                    </button>
                </Modal.Header>
                <Modal.Body>
                    {renderFormFields()}
                </Modal.Body>
                <Modal.Footer>
                    <button
                        type="button"
                        className="btn btn-info"
                        onClick={handleSearch}
                    >
                        <i className="fas fa-search"></i> Tìm kiếm
                    </button>
                    <button type="button" className="btn btn-info" onClick={toggleModal}>
                        <i className="fas fa-times"></i> Đóng
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default SearchForm;